import React, {useEffect, useState} from 'react';
import $ from "jquery";
import {GET_COL_AGGREGATE_DATA} from "../../api";
import cogoToast from "cogo-toast";
import formatNumber from "../../utils/formatNumber";
import exportToExcel from "../../utils/exporter";
import {capitalize} from "../../utils/capitalize";
import moment from "moment";
import {useSelector} from "react-redux";

let type = null;
let past_date = [
    {name: "Last 24 Hours", value: 1},
    {name: "Last 7 Days", value: 7},
    {name: "Last 14 Days", value: 14},
    {name: "Last 30 Days", value: 30},
    {name: "Last 6 Months", value: 182},
    {name: "Last 12 Months", value: 365}
];

let currDateRange = null;
let filter = {};

const DTLeaderBoard = ({id}) => {
    const token = localStorage.getItem('jwtToken');
    const [exportLoading, setExportLoading] = useState(false);
    const auth = useSelector((state) => state.auth.user);

    useEffect(() => {

        let table = $('#leaderboard-table').DataTable({
            responsive: true,
            language: {
                processing: '<div class="spinner-border"></div><p class="mg-t-10 tx-12">Collecting Leaderboard Data</p>'
            },
            searching: true,
            lengthMenu: [[10], [10]],
            ordering: false,
            info: true,
            bFilter: false,
            processing: true,
            pageLength: 10,
            serverSide: true,
            ajax: (data, callback) => {
                $.ajax(GET_COL_AGGREGATE_DATA, {
                    type: 'POST',
                    headers: {
                        "Authorization": token
                    },
                    contentType: 'application/json',
                    data: JSON.stringify({
                        query: $('.dataTables_filter input').val(),
                        collection: "users",
                        filter: [
                            {
                                $match: auth.user.role === 'admin' ? {} : {admin: `ObjectId(${auth.user.sub})`}
                            },
                            {
                                $lookup: {
                                    from: "submissions",
                                    let: { userId: "$_id" },
                                    pipeline: [
                                        {
                                            $match: {
                                                $expr: {
                                                    $eq: ["$user", "$$userId"]
                                                }
                                            }
                                        },
                                        {
                                            $match: {
                                                approve: true
                                            }
                                        }
                                    ],
                                    as: "submissions"
                                }
                            },
                            {
                                $lookup: {
                                    from: "tasks",
                                    localField: "_id",
                                    foreignField: "user",
                                    as: "tasks"
                                }
                            },
                            {
                                $addFields: {
                                    submission_count: {
                                        $size: { $ifNull: ["$submissions", []] }
                                    },

                                    task_count: {
                                        $size: { $ifNull: ["$tasks", []] }
                                    }
                                }
                            },
                            {
                                $match: {
                                    submission_count: { $gte: 1 }
                                }
                            },
                            {
                                $project: {
                                    _id: 1,
                                    name: 1,
                                    active: 1,
                                    mobile_number: 1,
                                    submission_count: 1,
                                    task_count: 1
                                }
                            },
                            { $sort: { submission_count: -1 } },
                            {
                                $facet: {
                                    results: [
                                        { $skip: data.start },
                                        { $limit: data.length }
                                    ],
                                    totalCount: [
                                        { $count: "total" }
                                    ]
                                }
                            }
                        ]
                    }),
                    success : function(res) {
                        let array = [];
                        res.data[0].results.map((data) => {
                            array.push({raw: data})
                        });

                        callback({
                            recordsTotal: res.data[0].totalCount[0] ? res.data[0].totalCount[0].total : 0,
                            recordsFiltered: res.data[0].totalCount[0] ? res.data[0].totalCount[0].total : 0,
                            data: array
                        });
                    },
                    error: function(err) {
                        cogoToast.error( err.responseJSON['error'].details !== undefined ? err.responseJSON['error'].details[0].message : err.responseJSON['error'], {position: "top-right", hideAfter: 5});
                    }
                });
            },
            "columns": [
                {"data": "raw"},
                {"data": "raw"},
                {"data": "raw"},
                {"data": "raw"}
            ],
            "columnDefs": [
                {
                    "render": function (data) {
                        return `<nav class="nav nav-icon-only"><a href="#/user/${data?._id}" class="nav-label tx-color-01" target="_blank"> ${capitalize(data?.name || "User not found")}</a></nav>`
                    },
                    "targets": 0
                },
                {
                    "render": function (data) {
                        return data.mobile_number;
                    },
                    "targets": 1
                },
                {
                    "render": function (data) {
                        return {
                            true : `<span class="badge badge-success tx-white">Active</span>`,
                            false : `<span class="badge badge-danger tx-white">Inactive</span>`,
                        }[data.active];
                    },
                    "targets": 2
                },
                {
                    "render": function (data) {
                        return formatNumber(data.submission_count);
                    },
                    "targets": 3
                }
            ]
        });

        return () => {
            table.destroy();
            type = null;
            filter = {};
            currDateRange = null;
        }

    }, [id]);

    const reloadTable = () => {
        $('#leaderboard-table').DataTable().ajax.reload(null, false);
    };

    const handleFilterSelect = (value) => {
        filter = Object.assign(filter, {
            "source": value
        });

        $("#tx-filter-level").text(value);
        reloadTable();
    };

    return (
        <div>
            <div className="d-flex tx-18 mg-b-20 justify-content-between">
                <div className="d-flex">
                    {/*<div className="dropdown">*/}
                    {/*    <a href="javascript:void(0)" className="tx-13 link-03 mg-l-5 pd-0-f outline-none dropdown-toggle" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><span id="tx-support-level">Select Date</span></a>*/}
                    {/*    <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">*/}
                    {/*        {past_date.map((item, index) => (*/}
                    {/*            <a className="dropdown-item" href="javascript:void(0)" key={index} onClick={handleDateSelect.bind(null, item.value, item.name)}>{item.name}</a>*/}
                    {/*        ))}*/}
                    {/*    </div>*/}
                    {/*</div>*/}

                    {/*<div className="dropdown ml-3">*/}
                    {/*    <a href="javascript:void(0)" className="tx-13 link-03 mg-l-5 pd-0-f outline-none dropdown-toggle" id="dropdownSelectButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><span id="tx-filter-level">| Filter By</span></a>*/}
                    {/*    <div className="dropdown-menu" aria-labelledby="dropdownSelectButton">*/}
                    {/*        <a className="dropdown-item" href="javascript:void(0)" onClick={handleFilterSelect.bind(null, "post")}>Post</a>*/}
                    {/*        <a className="dropdown-item" href="javascript:void(0)" onClick={handleFilterSelect.bind(null, "comment")}>Comment</a>*/}
                    {/*        <a className="dropdown-item" href="javascript:void(0)" onClick={handleFilterSelect.bind(null, "report")}>Report</a>*/}
                    {/*        <a className="dropdown-item" href="javascript:void(0)" onClick={handleFilterSelect.bind(null, "audio")}>Radio</a>*/}
                    {/*    </div>*/}
                    {/*</div>*/}
                </div>
                {/*{exportLoading ? <button disabled className="btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5"><span className="spinner-border spinner-border-sm mg-r-10" role="status" aria-hidden="true"/> Exporting</button> : <button className="btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5" onClick={exportData.bind()}><i className="wd-10 mg-r-5 fa fa-upload"></i> Export</button>}*/}
            </div>
            <table id="leaderboard-table" className="table" style={{ width: "100%" }}>
                <thead>
                <tr>
                    <th className="wd-25p">Name</th>
                    <th className="wd-25p">Mobile Number</th>
                    <th className="wd-25p">Status</th>
                    <th className="wd-25p tx-success">Completed Tasks</th>
                </tr>
                </thead>
            </table>
        </div>
    );
};

export default DTLeaderBoard;
